export default "__VITE_ASSET__1b8f2a9b__"